import React from "react";
import Typography from "../Typography";
import SearchDurationArrowIconSvg from "../Icons/SearchDurationArrowIcon";

import styles from "./listLinks.module.scss";

type Props = {
  list: Array<any>,
  linkComponent: any
};

type ListItemProps = {
  title: string,
  distance: number,
  href: string,
  linkComponent: any
};

const ListItem = ({ title, distance, href, linkComponent }: ListItemProps) => {
  return (
    <>
      {linkComponent(
        href,
        <div className={styles.base}>
          <div className={styles.left}>
            <Typography
              size="primary"
              color="brand"
              bold
              className={styles.title}
            >
              {title}
            </Typography>
            <Typography size="subtext" className={styles.distance}>
              <div>{distance} miles away</div>
            </Typography>
          </div>
          <div className={styles.right}>
            <SearchDurationArrowIconSvg />
          </div>
        </div>
      )}
    </>
  );
};

const ListLinks = ({ list, linkComponent }: Props) => {
  return (
    <ul className={styles.list}>
      {list.map(({ title, distance, href }) => (
        <li key={title} className={styles.item}>
          <ListItem
            title={title}
            distance={distance}
            href={href}
            linkComponent={linkComponent}
          />
        </li>
      ))}
    </ul>
  );
};

export default ListLinks;
